module.exports = __webpack_public_path__ + "media/venue/webinars@3x-34dd624f.png";